module.exports = __webpack_public_path__ + "static/media/push-lecture.ea4f1ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/push-lecture.png
// module id = 163
// module chunks = 6